module.exports = __webpack_public_path__ + "static/image3-c3fbfa8d14832bfca0ef3405fa9a9dd7.jpg";